
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-creator",
      function () {
        return require("private-next-pages/content-creator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-creator"])
      });
    }
  